/**
 * Csv Schema of TokenPush
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {TokenPush} from '@/model/resource/TokenPush'

/* TODO: review generated schema */
export class CsvTokenPushSchema extends Schema {
  readonly name = 'CsvTokenPush'

  readonly fieldSet: FieldSet<TokenPush> = {
    idTokenPushPk: schema => schema.model.idTokenPushPk,
    motorista: schema => schema.model.motorista?.$id ?? null,
    token: schema => schema.model.token,
    modeloAparelho: schema => schema.model.modeloAparelho,
    marcaAparelho: schema => schema.model.marcaAparelho,
  }
}
